import { Navigate, useSearchParams } from 'react-router';
import { EscalationPolicySection } from '@/modules/escalation-policy/escalation-policy-section';
import { SettingsBody, SettingsPage } from '@/modules/settings';

/** Settings › Escalations: the brand's default for each escalation. Its log moved to Logs. */
export default function EscalationsPage() {
	const [searchParams] = useSearchParams();
	if (searchParams.get('tab') === 'logs') return <Navigate to='/settings/logs?tab=escalations' replace />;
	return (
		<SettingsPage title='Escalations'>
			<SettingsBody>
				<EscalationPolicySection />
			</SettingsBody>
		</SettingsPage>
	);
}
